module.exports = __webpack_public_path__ + "wallpaper-min.jpg?530020994520f8a9d98f61515c3c1ed8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wallpaper-min.jpg
// module id = 361
// module chunks = 0